module.exports = __webpack_public_path__ + "img/Rectangle.1dc9a6fd.png";